import { PlatformZoomConfig } from "./types";

/**
 * =====================================================
 * 鼠标事件模块 - 配置常量
 * =====================================================
 */

/**
 * 视口缩放限制
 * 从 canvasConfig 导入，用于限制缩放范围
 */
export { VIEWPORT_ZOOM_LIMITS } from "@/views/workspace/board/helper/canvasConfig";

/**
 * 各平台的缩放快捷键配置
 * - Mac: Cmd + 滚轮
 * - Windows: Ctrl + 滚轮 或 Alt + 滚轮
 * - Linux: Ctrl + 滚轮
 */
export const ZOOM_CONFIG: PlatformZoomConfig = {
  mac: {
    modifierKey: "metaKey", // Cmd 键
    ctrlKey: "ctrlKey", // Ctrl 键（辅助快捷键）
    mouseWheelSensitivity: 0.999, // 鼠标滚轮灵敏度
    trackpadSensitivity: 0.99, // 触摸板灵敏度
    label: "Cmd + 滚轮 / Ctrl + 滚轮"
  },
  windows: {
    modifierKey: "ctrlKey", // Ctrl 键（主快捷键）
    altKey: "altKey", // Alt 键（辅助快捷键）
    mouseWheelSensitivity: 0.999,
    trackpadSensitivity: 0.99,
    label: "Ctrl + 滚轮 / Alt + 滚轮"
  },
  linux: {
    modifierKey: "ctrlKey", // Ctrl 键
    mouseWheelSensitivity: 0.999,
    trackpadSensitivity: 0.99,
    label: "Ctrl + 滚轮"
  }
};

/**
 * 滚轮类型检测阈值
 * 超过此值认为是鼠标滚轮，否则认为是触摸板
 */
export const WHEEL_DELTA_THRESHOLD = 40;

/**
 * 防抖延迟时间 (ms)
 * 用于中键拖拽时避免频繁计算坐标偏移
 */
export const CALC_OFFSET_DEBOUNCE_MS = 100;

/**
 * 坐标偏移缓存有效期 (ms)
 * 超过此时间后下次操作会重新计算
 */
export const CALC_OFFSET_VALIDITY_MS = 300;

/**
 * 滤镜处理每帧时间预算 (ms)
 * 用于异步处理图片滤镜，避免主线程卡死
 */
export const FILTER_PROCESS_TIME_BUDGET_MS = 16;
